import { render } from "./SegmentedChoice.vue?vue&type=template&id=1e2a70c7&scoped=true"
import script from "./SegmentedChoice.vue?vue&type=script&lang=js"
export * from "./SegmentedChoice.vue?vue&type=script&lang=js"

import "./SegmentedChoice.vue?vue&type=style&index=0&id=1e2a70c7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dell\\Documents\\eChook\\Code\\gpt-nano-configurator\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e2a70c7"]])

export default __exports__